import { render, staticRenderFns } from "./popup-voucher.vue?vue&type=template&id=45a35dfa&"
import script from "./popup-voucher.vue?vue&type=script&lang=js&"
export * from "./popup-voucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports